<template>
    <div>
        <img :src="model.logo" aria-hidden="true" alt="decorative-drops-icon" />
        <div class="container-fluid" :class="{menuOpen: menuOpen}">
            <div class="d-flex container-fluid justify-content-between align-items-center">
                <transition name="fade">
                    <search-overlay v-if="showOverlay" :model="model.searchBar"></search-overlay>
                </transition>
                <div>
                    <a :href="model.startPageUrl" class="hsy-icon" :aria-label="model.logoText">
                        <svg class="icon icon-logo-text">
                            <use xlink:href="#icon-logo-text"></use>
                        </svg>
                    </a>
                </div>
                <div class="d-flex">
                     <form class="col-auto" @keyup.enter="showOverlay" @click="showOverlay" role="search">
                        <button aria-haspopup="true" :aria-label="model.searchBar.langSearchLabel" type="button" class="unstyled-button" :aria-expanded="overlayVisible ? 'true' : 'false'">
                          <svg class="icon icon-hsy-icon-search-bold ml-2">
                            <use role="presentation" xlink:href="#icon-hsy-icon-search-bold"></use>
                          </svg>
                        </button>    
                    </form>
                    <button aria-haspopup="true" :aria-expanded="menuOpen ? 'true' : 'false'" class="unstyled-button px-0 ml-1" :aria-label="model.menuButtonLabel" @click="menuOpen = !menuOpen">
                        <svg v-if="!menuOpen" class="icon icon-hsy-icon-menu"><use xlink:href="#icon-hsy-icon-menu"></use></svg>
                        <svg v-if="menuOpen" class="icon icon-hsy-icon-close-bold"><use xlink:href="#icon-hsy-icon-close-bold"></use></svg>
                    </button>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-if="menuOpen" class="container-fluid mobile-nav">
                <div class="main-nav mb-4 position-relative">
                    <ul :aria-label="model.mainNavigationHeading">
                        <li v-for="(navItem, index) in model.mainNavigation" :key="index">
                            <a v-if="navItem.isCurrentPage" class="main-nav--first-level-link" :class="currentSubNav === navItem ? 'is-open main-nav--first' : ''" :href="navItem.url" aria-current="page">{{ navItem.name }}</a>
                            <a v-else :href="navItem.url" class="main-nav--first-level-link" :class="currentSubNav === navItem ? 'is-open' : ''">{{ navItem.name }}</a>
                            <button v-if="navItem.subLinks.length > 0" class="unstyled-button position-absolute right-0" @click="setSubnaviStructure(navItem)" :aria-label="navItem.name" :aria-haspopup="navItem.subLinks.length > 0 ? true : false" :aria-expanded="currentSubNav !== null">
                                <svg v-if="currentSubNav === null || currentSubNav.subLinks !== navItem.subLinks" class="icon icon-hsy-icon-plus-bold">
                                    <use role="presentation" xlink:href="#icon-hsy-icon-plus-bold"></use>
                                </svg>
                                <svg v-else class="icon icon-hsy-icon-minus-bold">
                                    <use role="presentation" xlink:href="#icon-hsy-icon-minus-bold"></use>
                                </svg>
                            </button>
                            <section v-if="currentSubNav === navItem">
                                <ul>
                                    <li v-for="(navItem, index) in currentSubNav.subLinks" :key="index" class="main-nav--second-level-list-item position-relative">
                                        <a :href="navItem.url" class="main-nav--second-level-link" :class="currentSub3rdLvlNav === navItem.subLinks ? 'is-open' : ''">{{ navItem.name }}</a>
                                        <button v-if="navItem.subLinks.length > 0" class="unstyled-button position-absolute right-0" @click="set3rdLvlNav(navItem)" :aria-label="navItem.name" :aria-haspopup="navItem.subLinks.length > 0 ? true : false" :aria-expanded="currentSub3rdLvlNav !== null">
                                            <svg v-if="currentSub3rdLvlNav === null || currentSub3rdLvlNav !== navItem.subLinks" class="icon icon-hsy-icon-plus-bold">
                                                <use role="presentation" xlink:href="#icon-hsy-icon-plus-bold"></use>
                                            </svg>
                                            <svg v-else class="icon icon-hsy-icon-minus-bold">
                                                <use role="presentation" xlink:href="#icon-hsy-icon-minus-bold"></use>
                                            </svg>
                                        </button>
                                        <section v-if="currentSub3rdLvlNav !== null && currentSub3rdLvlNav === navItem.subLinks">
                                            <ul>
                                                <li v-for="(navItem, index) in navItem.subLinks" :key="index" class="main-nav--third-level-list-item position-relative">
                                                    <a :href="navItem.url" class="main-nav--third-level-link" :class="currentSub4thLvlNav === navItem.subLinks ? 'is-open' : ''">{{ navItem.name }}</a>
                                                    <button v-if="navItem.subLinks && navItem.subLinks.length > 0" class="unstyled-button position-absolute right-0" @click="set4thLvlNav(navItem)" :aria-label="navItem.name" :aria-haspopup="navItem.subLinks.length > 0 ? true : false" :aria-expanded="currentSub4thLvlNav !== null">
                                                        <svg v-if="currentSub4thLvlNav === null || currentSub4thLvlNav !== navItem.subLinks" class="icon icon-hsy-icon-plus-bold">
                                                            <use role="presentation" xlink:href="#icon-hsy-icon-plus-bold"></use>
                                                        </svg>
                                                        <svg v-else class="icon icon-hsy-icon-minus-bold">
                                                            <use role="presentation" xlink:href="#icon-hsy-icon-minus-bold"></use>
                                                        </svg>
                                                    </button>
                                                    <section v-if="currentSub4thLvlNav !== null && currentSub4thLvlNav === navItem.subLinks">
                                                        <ul>
                                                            <li v-for="(navItem, index) in navItem.subLinks" :key="index" class="main-nav--third-level-list-item position-relative">
                                                                <a :href="navItem.url" class="main-nav--third-level-link">{{ navItem.name }}</a>
                                                            </li>
                                                        </ul>
                                                    </section>
                                                </li>
                                            </ul>
                                        </section>
                                    </li>
                                </ul>
                            </section>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul role="navigation" :aria-label="model.quickLinksHeading">
                        <li v-for="(shortcut, index) in model.quickLinks" :key="index + 'sc'">
                            <a class="header-supportlink" :href="shortcut.url">{{ shortcut.name }}</a>
                        </li>
                    </ul>
                    <div class="row pb-5">
                        <ul role="region" class="language-selection-links" :aria-label="model.languageSelectHeading">
                            <li v-for="(lang, index) in model.languages" :key="index + 'l'" class="col-auto">
                                <a v-if="lang.active"
                                   :href="lang.href"
                                   :aria-label="lang.label"
                                   :class="lang.active"
                                   aria-current="page"
                                   class="text-uppercase"
                                >
                                    {{ lang.title }}
                                </a>
                                <a v-else :href="lang.href" :aria-label="lang.label" class="text-uppercase">{{ lang.title }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <img class="mobile-navi-big-image lazyload" data-src="/img/mobile-navi-drops.svg" aria-hidden="true" alt="">
            </div>
        </transition>
    </div>
</template>
<script>
    import searchOverlay from './search-overlay.vue';
    import { mapState } from 'vuex';
    export default {
        components: {
            'search-overlay': searchOverlay
        },
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                menuOpen: false,
                currentSubNav: null,
                currentSub3rdLvlNav: null,
                currentSub4thLvlNav: null,
            }
        },
        computed: mapState({
            overlayVisible: state => state.showOverlay
        }),
        mounted: function () {
            setTimeout(() => {
                this.goToAnchorInUrl();
            }, 500)
        },
        methods: {
            setSubnaviStructure(structure) {
                const hasStructure = structure.subLinks.length > 0;
                if(hasStructure === false) {
                    // No subitems, might be a minisite
                    window.location.href = structure.url;
                    return; 
                }
                if(this.currentSubNav === structure) {
                    // Same main item clicked again, close this submenu
                    this.currentSubNav.active = false;
                    this.currentSubNav = null;
                    return;
                } else {
                    if(this.currentSubNav !== null) this.currentSubNav.active = false;
                    this.currentSubNav = structure;
                    this.currentSubNav.active = true;
                }
            },
            set3rdLvlNav(navItem) {
                if(this.currentSub3rdLvlNav === navItem.subLinks) {
                    this.currentSub3rdLvlNav = null;
                    this.currentSub4thLvlNav = null;
                    return;
                }
                this.currentSub3rdLvlNav = navItem.subLinks;
                this.currentSub4thLvlNav = null;
            },
            set4thLvlNav(navItem) {
                if(this.currentSub4thLvlNav === navItem.subLinks) {
                    this.currentSub4thLvlNav = null;
                    return;
                }
                this.currentSub4thLvlNav = navItem.subLinks;
            },
            showOverlay() {
                this.$store.commit('showOverlay');
            },
            goToAnchorInUrl() {
                if (window.location.hash) {
                    let anchorId = window.location.hash.substring(1);
                    document.getElementById(anchorId).scrollIntoView();
                }
            },
        },
        watch: {
            menuOpen: function(val) {
                if(val === false) {
                    this.currentSubNav = null;
                    this.currentSub3rdLvlNav = null;
                    this.currentSub4thLvlNav = null;
                }
            }
        }
    }
</script>
